'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var SelectAdvanced = require('../../02.molecules/SelectAdvanced/SelectAdvanced.js');
require('./_index.scss.js');

/*************
 * ClassNames
 *************/

var CLASSNAME = 'varta-search-vehicle-type',
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCol = "".concat(CLASSNAME, "__col"); // default year options if none could be loaded

var defaultYears = [];

for (var i = new Date().getFullYear(); i >= 1947; i = i - 1) {
  var y = {
    key: i,
    label: String(i),
    value: String(i)
  };
  defaultYears.push(y);
}
/**
 * 
 * @param {*} param0 
 * @returns 
 */


function SearchVehicleType(_ref) {
  var title = _ref.title,
      locale = _ref.locale,
      token = _ref.token,
      year = _ref.year,
      vehicleTypeId = _ref.vehicleTypeId,
      modelId = _ref.modelId,
      engineId = _ref.engineId,
      manufacturerId = _ref.manufacturerId,
      years = _ref.years,
      manufacturer = _ref.manufacturer,
      modelline = _ref.modelline,
      modeltype = _ref.modeltype,
      onUpdateEngineId = _ref.onUpdateEngineId,
      onFetchSearchStart = _ref.onFetchSearchStart,
      onValueChange = _ref.onValueChange,
      twoColumns = _ref.twoColumns,
      bold = _ref.bold,
      light = _ref.light,
      i18n = _ref.i18n,
      isLoading = _ref.isLoading;

  function onSelectYear(year) {
    onFetchSearchStart({
      locale: locale,
      vehicleTypeId: vehicleTypeId,
      year: year,
      manufacturerId: null
    }, token);
    onValueChange();
  }

  function onSelectManufacturer(manufacturerId) {
    onFetchSearchStart({
      locale: locale,
      vehicleTypeId: vehicleTypeId,
      year: year,
      manufacturerId: manufacturerId,
      modelId: null
    }, token);
    onValueChange();
  }

  function onSelectModel(modelId) {
    onFetchSearchStart({
      locale: locale,
      vehicleTypeId: vehicleTypeId,
      year: year,
      manufacturerId: manufacturerId,
      modelId: modelId,
      engineId: null
    }, token);
    onValueChange();
  }

  function onSelectEngine(engineId) {
    onUpdateEngineId(engineId);
    onValueChange();
  }

  var classRow = twoColumns ? cnRow : '';
  var classCol = twoColumns ? cnCol : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: CLASSNAME
  }, title && /*#__PURE__*/React__default.createElement("h1", null, title), /*#__PURE__*/React__default.createElement("div", {
    className: classRow
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classCol
  }, /*#__PURE__*/React__default.createElement(SelectAdvanced, {
    isLoading: typeof isLoading === 'undefined' && !years.length,
    name: "year",
    bold: bold,
    light: light,
    title: i18n.year,
    placeholder: i18n.placeholder,
    value: year || null,
    options: years.length > 0 ? years : defaultYears,
    onChange: function onChange(_ref2) {
      var id = _ref2.value;
      return onSelectYear(id);
    },
    required: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: classCol
  }, /*#__PURE__*/React__default.createElement(SelectAdvanced, {
    isLoading: isLoading === 'TYPE_MANUFACTURER',
    name: "manufacturer",
    bold: bold,
    light: light,
    title: i18n.manufacturer,
    disabled: manufacturer.length < 1,
    placeholder: manufacturer.length > 0 ? i18n.placeholder : '',
    value: manufacturerId || null,
    options: manufacturer,
    onChange: function onChange(_ref3) {
      var id = _ref3.value;
      return onSelectManufacturer(id);
    },
    required: true
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: classRow
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classCol
  }, /*#__PURE__*/React__default.createElement(SelectAdvanced, {
    isLoading: isLoading === 'TYPE_MODELLINE',
    name: "model",
    bold: bold,
    light: light,
    title: i18n.model,
    disabled: modelline.length < 1,
    placeholder: modelline.length > 0 ? i18n.placeholder : '',
    value: modelId || null,
    options: modelline,
    onChange: function onChange(_ref4) {
      var id = _ref4.value;
      return onSelectModel(id);
    },
    required: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: classCol
  }, /*#__PURE__*/React__default.createElement(SelectAdvanced, {
    isLoading: isLoading === 'TYPE_MODELTYPE',
    bold: bold,
    light: light,
    title: i18n.engine,
    disabled: modeltype.length < 1,
    placeholder: modeltype.length > 0 ? i18n.placeholder : '',
    value: engineId || null,
    options: modeltype,
    onChange: function onChange(_ref5) {
      var id = _ref5.value;
      return onSelectEngine(id);
    },
    required: true
  }))));
}
SearchVehicleType.propTypes = {
  title: PropTypes.string,
  locale: PropTypes.string.isRequired,
  token: PropTypes.string,
  year: PropTypes.string,
  vehicleTypeId: PropTypes.string,
  modelId: PropTypes.string,
  engineId: PropTypes.string,
  manufacturerId: PropTypes.string,
  years: PropTypes.array,
  manufacturer: PropTypes.array,
  modelline: PropTypes.array,
  modeltype: PropTypes.array,
  onValueChange: PropTypes.func,
  onUpdateEngineId: PropTypes.func.isRequired,
  onFetchSearchStart: PropTypes.func.isRequired,
  twoColumns: PropTypes.bool,
  isLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['TYPE_MANUFACTURER', 'TYPE_MODELLINE', 'TYPE_MODELTYPE'])]),
  bold: PropTypes.bool,
  light: PropTypes.bool,
  i18n: PropTypes.shape({
    year: PropTypes.string,
    manufacturer: PropTypes.string,
    model: PropTypes.string,
    engine: PropTypes.string,
    placeholder: PropTypes.string
  }).isRequired
};
SearchVehicleType.defaultProps = {
  years: [],
  manufacturer: [],
  modelline: [],
  modeltype: [],
  onValueChange: function onValueChange() {
    return void 0;
  },
  i18n: {}
};

module.exports = SearchVehicleType;
